import React from 'react';
import WorkspaceLayout from '../components/WorkspaceLayout';
import WorkspaceBoard from '../components/workspace/WorkspaceBoard';

function DeveloperWorkspacePage() {
  return (
    <WorkspaceLayout
      active="/Developer"
      title="작업관리"
      description="프로젝트 이슈, 업무 기록, 직무별 게시판을 한 화면에서 관리합니다. 기존 글쓰기와 댓글 기능은 유지하고, 탐색 구조만 새 작업실 디자인으로 정리했습니다."
      statusTitle="작업관리 구성"
      metrics={[
        { label: '직무 게시판', value: '7개' },
        { label: '글쓰기', value: '지원' },
        { label: '댓글', value: '지원' },
      ]}
      toolbarTitle="직무별 작업 게시판"
      toolbarText="프로그래밍, 모델링, 디자인, 인프라, 미디어, 기획, 업무일지를 카테고리와 함께 관리합니다."
      badge="기존 기능 유지"
    >
      <WorkspaceBoard />
    </WorkspaceLayout>
  );
}

export default DeveloperWorkspacePage;
